export default __webpack_public_path__ + "static/media/menu_healthcare.9b24828e.png";